import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { TodoListProps } from "./types";

export const details = {
  name: "TodoList",
  description: "Simple todo list widget",
  tags: ["Productivity", "Organization"],
  category: "Widget",
  grid: {
    extraSmall: [1, 1],
    default: [3, 3],
    large: [4, 4],
  },
  gridNames: {
    extraSmall: "Extra Small",
    default: "Medium",
    large: "Large",
  },
  app: lazy(() => import("./App").then(m => ({ default: m.AppView }))),
  context: lazy(() => import("./Context").then(m => ({ default: m.Context }))),
  defaultProps: {
    showQuickAdd: true,
  },
  contextProvider: lazy(() => import("./ContextProvider")),
  integrationsUsed: ["InternalTodo"],
  fields: [],
} as ElementDetails<TodoListProps>;
